// src/serviceWorkerRegistration.js
// Registers /service-worker.js on production builds. CRA's dev server does
// not serve service workers, so we no-op outside production. See
// docs/system/offline-mode.md.

const SW_URL = '/service-worker.js';

export function register() {
	if (process.env.NODE_ENV !== 'production') return;
	if (typeof window === 'undefined') return;
	if (!('serviceWorker' in navigator)) return;

	window.addEventListener('load', () => {
		navigator.serviceWorker
			.register(SW_URL)
			.then((registration) => {
				if (typeof console !== 'undefined') {
					console.info('Service worker registered:', registration.scope);
				}
			})
			.catch((err) => {
				if (typeof console !== 'undefined') {
					console.warn('Service worker registration failed:', err);
				}
			});
	});
}

export function unregister() {
	if (typeof window === 'undefined') return;
	if (!('serviceWorker' in navigator)) return;
	navigator.serviceWorker
		.getRegistrations()
		.then((registrations) => {
			registrations.forEach((reg) => reg.unregister());
		})
		.catch(() => {
			// Ignore.
		});
}
